import { mapState } from "pinia";
import { defineComponent } from "vue";

import { NNumberAnimation } from "naive-ui";
import ComponentBase from "~/components/component-base";
import WidgetIndicator from "~/components/widget-indicator/widget-indicator.vue";
import { useDashboardStore } from "~/store/dashboard.store";

export default defineComponent({
  extends: ComponentBase,

  components: {
    WidgetIndicator,
    NNumberAnimation,
  },

  computed: {
    ...mapState(useDashboardStore, ["indicators", "loading"]),

    count(): number {
      return this.indicators?.offline?.value;
    },

    variation(): number {
      return this?.indicators?.offline?.variation;
    },

    color(): string {
      if(this.variation > 0) {
        return 'has-text-danger';
      } else if (this.variation < 0) {
        return 'has-text-success';
      } else {
        return '';
      }
    }
  },

  watch: {
  },
});
